import * as React from 'react';
import { MathFunctions } from '../../utils/math';
import { IPageButtonProps, IPagingProps, IPageNumber, IPageButton } from './pages.types';

const PageButton: React.FC<IPageButtonProps> = ({ page, onPageSelect }) => {

    const getContent = (): string => {
        if (page.isEllipsis)
            return '&hellip;';

        else if (page.isLeftMost)
            return `Page ${page.number.toString()}`;

        else if (page.isRightMost)
            return page.numberOfPages.toString();

        else return page.number.toString();
    }

    return (
        <>
            {
                page.isEllipsis ?
                    <li className="pagination-li-ellipses">
                        ...
                  </li>
                    :
                    <li className={`pagination-li ${page.active}`}>
                        <a type="button" onClick={() => onPageSelect(page.number)} className={`${page.active ? "" : "text-underline"} pagination-link` }>
                            {getContent()}
                        </a>
                    </li>
            }

        </>
    );
}

const Pages: React.FC<IPagingProps> = ({ paging, numberOfButtonsToShow, onPageSelect }) => {
    const getPages = () => {
        const numberOfPages = paging.totalPages;
        const pagesMiddle = Math.ceil(numberOfButtonsToShow / 2);
        //Create list of page number objects
        var pageNumbers = [];
        for (let index = 0; index < (numberOfPages); index++) {
            pageNumbers[index] = { number: index + 1, active: (index + 1) === paging.pageNumber } as IPageNumber;
        }

        //Filter list to only the numbers we will display
        const centered = MathFunctions.getRangeCenteredAt(paging.pageNumber, numberOfButtonsToShow, pageNumbers);

        return centered
            .map((page, i) => {
                //Calculate page-specific attributes
                const isLeftMost = i === 0 || page.number == 1;
                const isRightMost = page.number !== numberOfPages && page.number !== (numberOfPages - 1) && (i === centered.length - 1);

                const isLeftEllipsis = ((numberOfPages > numberOfButtonsToShow) && (paging.pageNumber > pagesMiddle)) && i === 1;
                const isRightEllipsis = ((numberOfPages > numberOfButtonsToShow) && ((numberOfPages - paging.pageNumber) > pagesMiddle)) && i === centered.length - 2;
                const isEllipsis = isLeftEllipsis || isRightEllipsis;

                const number = isLeftMost ? 1
                    : isRightMost ? numberOfPages
                        : page.number;

                return {
                    ...page,
                    isLeftMost,
                    isRightMost,
                    number,
                    numberOfPages,
                    isEllipsis
                } as IPageButton;
            });
    }

    const renderPages = (page: IPageButton, i: number) => {
        return <PageButton
            page={page}
            key={i}
            onPageSelect={onPageSelect} />;
    }

    return <>
        {getPages().map(renderPages)}
    </>
}

export default Pages;